var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "d-lg-flex me-0 mb-1 mb-lg-0 d-lg-flex align-items-center",
      },
      [
        _c("div", { staticClass: "d-flex align-items-center" }, [
          _c("span", {
            staticClass: "ob1-capsule ob1-capsule-information pe-1 fw-normal",
            domProps: { innerHTML: _vm._s(_vm.title) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "d-none d-md-block" }, [
            _c("span", {
              staticClass: "fw-normal",
              domProps: { innerHTML: _vm._s(_vm.text) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row px-1 d-md-none" }, [
            _c("div", {
              staticClass: "col-12 px-0 fw-normal",
              domProps: { innerHTML: _vm._s(_vm.text) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex mt-1 mt-lg-0 ms-lg-1 align-items-center" },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("span", { staticClass: "icon icon-reload" }, [_vm._v(" ")]),
                _vm._v(" "),
                _c("ob1-liens", {
                  staticClass: "d-flex fw-bold py-0",
                  attrs: {
                    "is-button": _vm.modifyButton.isButton,
                    text: _vm.modifyButton.text,
                    href: _vm.modifyButton.href,
                    "is-mini": "",
                    "no-decoration": "",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.deleteButton
              ? _c(
                  "div",
                  { staticClass: "ms-1 d-flex align-items-center" },
                  [
                    _c("span", { staticClass: "icon icon-trash" }, [
                      _vm._v(" "),
                    ]),
                    _vm._v(" "),
                    _c("ob1-liens", {
                      staticClass: "d-flex fw-bold py-0",
                      attrs: {
                        "is-button": _vm.deleteButton.isButton,
                        text: _vm.deleteButton.text,
                        href: _vm.deleteButton.href,
                        "is-mini": "",
                        "no-decoration": "",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }